import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ClipLoader from "react-spinners/ClipLoader";
import {
  Button,
  Checbox,
  Input,
  SubTitle,
} from "../../Components/CustomComponents";
import { useSentNotificationMutation } from "../../Data/services/notificationApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import styles from "./styles/sendNotificationScreen.module.scss";

const SendNotificationScreen = ({ setPage }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      title: "",
      message: "",
      // user_type: [],
    },
  });
  // const [title, setTitle] = useState('');
  // const [notification, setNotification] = useState('');

  // const allOptions = ["User", "Shop", "All"];

  const [sendNotification, { isLoading }] = useSentNotificationMutation();

  const handleSendNotification = async (data) => {
    // const filteredUserTypes = data.user_type?.filter((type) => type !== "All");

    const payload = {
      ...data,
      // user_type: filteredUserTypes,
    };

    console.log(payload); // Just to verify

    try {
      const response = await sendNotification(data);

      console.log(response);

      if (response.data.code === 200) {
        SuccessToast(response?.data.message);
        reset();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      } else {
        Toast("An error occurred during login", "error");
      }
    }
  };

  return (
    <div className={styles.MainContainer}>
      {errors
        ? errors.title?.message
          ? Toast(errors.title?.message, "error")
          : Toast(errors.message?.message, "error")
        : null}
      <div className={styles.headerContainer}>
        <div>
          <SubTitle text={"Send Notification"} />
        </div>
        <Row>
          <Col md={12}>
            <Button
              text={
                isLoading ? <ClipLoader color="#0f0f0f" size="22px" /> : "Send"
              }
              classes={`fs-6 mb-2 mt-auto mt-3 mb-2 ${
                isLoading || !isValid ? "bg-dark-subtle" : ""
              }`}
              style={{ width: "100px" }}
              disabled={isLoading || !isValid}
              onClick={handleSubmit(handleSendNotification)}
            ></Button>
          </Col>
        </Row>
      </div>

      <div className={`mt-3 ${isLoading ? "blur-table" : ""}`}>
        <Form>
          <Controller
            control={control}
            name="title"
            rules={{
              required: "Title is required.",
            }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <InputGroup className="mb-3">
                <Input
                  placeholder="Title"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              </InputGroup>
            )}
          />

          <Controller
            control={control}
            name="message"
            rules={{
              required: "Notification Message is required.",
            }}
            render={({ field: { onChange, onBlur, value, ref } }) => (
              <InputGroup className="mb-3">
                <Input
                  placeholder="Notification"
                  type="textarea"
                  as="textarea"
                  rows={5}
                  value={value}
                  onChange={onChange}
                />
              </InputGroup>
            )}
          />

          {/* <Controller
            control={control}
            name="user_type"
            rules={{ required: true }}
            render={({ field: { onChange, value = [] } }) => {
              const handleIndividualChange = (type, isChecked) => {
                let newValue = [];

                if (isChecked) {
                  newValue = [...value, type];
                  // If all individual options are selected, add "All"
                  const updated = [...new Set(newValue)];
                  if (allOptions.every((opt) => updated.includes(opt))) {
                    newValue = [...updated, "All"];
                  }
                } else {
                  newValue = value.filter((v) => v !== type && v !== "All");
                }

                onChange([...new Set(newValue)]);
              };

              const handleAllChange = (isChecked) => {
                const newValue = isChecked ? [...allOptions, "All"] : [];
                onChange(newValue);
              };

              return (
                <InputGroup className="mb-3">
                  <label>
                    Select User Type
                    <Checbox
                      label="User"
                      classes="my-2"
                      checked={value.includes("User")}
                      onChange={(e) =>
                        handleIndividualChange("User", e.target.checked)
                      }
                    />
                    <Checbox
                      label="Shop"
                      classes="my-2"
                      checked={value.includes("Shop")}
                      onChange={(e) =>
                        handleIndividualChange("Shop", e.target.checked)
                      }
                    />
                  </label>
                </InputGroup>
              );
            }}
          /> */}
        </Form>
      </div>
    </div>
  );
};

export default SendNotificationScreen;
